<template>
    <section :id="uniqid" class="visuals vpad-100">
        <div class="pad">
            <div class="wrap">
                <div class="visuals-head">
                    <h2 class="h2">{{ title }}</h2>
                    <select v-if="visualTypes.length" v-model="visualTypeId" class="sort">
                        <option :value="null">{{ t('sort_by') }}</option>
                        <option v-for="visualType in visualTypes" :key="visualType.id" :value="visualType.id">{{ visualType.name }}</option>
                    </select>
                </div>
                <div class="visuals-body">
                    <div class="items">
                        <div v-for="visual in visuals" :key="visual.id" class="video-box">
                            <div class="poster" :style="{ backgroundImage: 'url(/files/' + visual.image + ')' }"></div>
                            <div class="content">
                                <div class="video-iframe"></div>
                                <a v-if="visual.file" href="#" class="play with-button" @click.prevent="videoStart(visual, $event)" :data-file="visual.file"></a>
                                <a v-else-if="visual.videoId && visual.videoPlatform" href="#" @click.prevent="videoStart(visual, $event)" class="play with-button" :data-platform="visual.videoPlatform" :data-id="visual.videoId"></a>
                            </div>
                        </div>
                    </div>

                    <a v-if="showLoadMoreButton" href="#" @click.prevent="loadMore()" class="load-more">
                        <img src="/images/load-more-white.svg" alt="load more">
                    </a>

                </div>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        props: {
            uniqid: {
                type: String,
                required: true
            },
            title: {
                type: String,
                required: true
            },
            locale: {
                type: String,
                required: true
            },
        },
        data() {
            return {
                initialized: false,
                isFetching: false,
                offset: 0,
                perPage: 6,
                total: 0,
                visuals: [],
                visualTypes: [],
                visualTypeId: null,
                t: window.t,
                resort: _.debounce(this._resort, 500)
            };
        },
        computed: {
            showLoadMoreButton() {
                if (this.isFetching) {
                    return false;
                }

                return this.total > this.visuals.length;
            },
        },
        mounted() {
            this.fetchData();
        },
        methods: {
            async fetchData(refetch = false) {
                if (this.isFetching) {
                    return;
                }

                this.isFetching = true;

                try {
                    const response = await axios.post('/visuals/data', {
                        initialized: this.initialized,
                        visual_type_id: this.visualTypeId,
                        offset: this.offset,
                        perPage: this.perPage,
                        locale: this.locale,
                        refetch,
                    });

                    if (response.data.hasOwnProperty('visuals')) {
                        if (refetch) {
                            this.visuals = response.data.visuals;
                        } else {
                            this.visuals = this.visuals.concat(response.data.visuals);
                        }
                    }

                    if (response.data.hasOwnProperty('visualTypes')) {
                        this.visualTypes = response.data.visualTypes;
                    }

                    if (response.data.hasOwnProperty('total')) {
                        this.total = response.data.total;
                    }

                    this.initialized = true;
                } catch (exc) {
                    console.error(exc);
                }

                this.isFetching = false;
            },
            async loadMore() {
                if (this.isFetching) {
                    return;
                }

                this.offset += this.perPage;
                await this.fetchData();
            },
            async _resort() {
                if (this.isFetching) {
                    return;
                }

                await this.fetchData(true);
            },
            videoStart(visual, event) {
                if (visual.file) {
                    inlineVideoStart(event.target);
                } else if(visual.videoId && visual.videoPlatform) {
                    videoStart(event.target)
                }
                // console.log({ visual, event })
            }
        },
        watch: {
            visualTypeId() {
                this.resort();
            }
        },
    }
</script>
